import { TranslateResult } from 'vue-i18n';

export type MessageTypes = 'info' | 'success' | 'error';

export interface MessageTypesStyle {
  background?: string;
  button: string;
}

export interface MessageTypesStyles {
  [styleKey: string]: MessageTypesStyle;
}

export const MessageTypesStylesDefs: MessageTypesStyles = {
  info: {
    background: undefined,
    button: 'yellow',
  },
  success: {
    background: undefined,
    button: 'green accent-2',
  },
  error: {
    background: 'red',
    button: 'black',
  },
};

export interface Message {
  text: string | TranslateResult;
  type: MessageTypes;
}
